'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { SquareLock02Icon } from '@/components/ui/icon/glyphs';
import { SegmentedControl } from '@/components/ui/segmented-control';

// onChange never fires (the shell is `pointer-events-none`), but the prop is
// required — a stable no-op keeps the control inert.
const NOOP = (): void => {};

/**
 * Non-interactive stand-in for the chart timeframe picker, shown on resolved
 * markets. The chart is frozen to its full creation→resolution history, so
 * there is no timeframe to switch — a single locked pill (lock icon + "Locked")
 * replaces the interval selector.
 *
 * Built on the same `chart`-variant `SegmentedControl` as the live picker so
 * the pill geometry matches exactly. `pointer-events-none` makes it inert
 * without the 50% dimming that the per-item `disabled` flag would apply.
 */
export function LockedTimeframeSelector() {
  const $ = _c(4);
  const t = useTranslations("chart");
  let t0;
  if ($[0] !== t) {
    t0 = t("interval_locked");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <SegmentedControl items={[{
      key: "locked",
      label: t0,
      icon: SquareLock02Icon
    }]} active="locked" onChange={NOOP} layoutId="chart-controls-locked-pill" className="pointer-events-none" />;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}